import styled from 'styled-components';
import {Space} from 'antd';

const StyledInvoicePreviewWithIcon = styled.span`
  align-items: center;
  display: inline-flex;
  justify-content: center;
`;

const StyledInvoicePreviewTooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 200px;
  min-width: 200px;
`;

const StyledInvoicePreviewTooltipBody = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
`;

const StyledInvoicePreviewTooltipFooter = styled(Space)`
  justify-content: center;
  margin-top: 8px;
  width: 100%;
`;

export {
  StyledInvoicePreviewWithIcon,
  StyledInvoicePreviewTooltipContent,
  StyledInvoicePreviewTooltipBody,
  StyledInvoicePreviewTooltipFooter,
}
